import * as moment from 'moment';
import {
  UPLOAD_REQUESTS_PAGINATION,
  UPLOAD_REQUESTS_UPDATE_DATA,
  UPLOAD_REQUESTS_UPDATE_FILTER,
  UPLOAD_REQUESTS_RESET_PAGINATION,
  UPLOAD_REQUESTS_ENABLE_LOADING,
  UPLOAD_REQUESTS_DISABLE_LOADING,
  UPLOAD_REQUESTS_RESET_DATA,
} from '../actions/constants';

const defaultState = {
  isLoading: false,
  uploadRequestsData: [],
  appliedFilters: {
    startDate: moment().subtract(30, 'day').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    dateFilterType: 'created_at',
    actionType: null,
  },
  pagination: {
    currentPageNumber: 1,
    total: 0,
    limitPerPage: 50,
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case UPLOAD_REQUESTS_UPDATE_DATA: {
      return {
        ...state,
        uploadRequestsData: action.data,
        pagination: {
          ...state.pagination,
          isNextPresent: action.isNextPresent,
          lastDateFieldValuePrev: action.data
            ? action.data.last_date_field_value_prev
            : null,
          lastDateFieldValueNext: action.data
            ? action.data.last_date_field_value_next
            : null,
        },
      };
    }
    case UPLOAD_REQUESTS_UPDATE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...defaultState.appliedFilters,
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }
    case UPLOAD_REQUESTS_RESET_DATA: {
      return {
        ...state,
        uploadRequestsData: [],
        pagination: {
          ...state.pagination,
          isNextPresent: false,
        },
      };
    }
    case UPLOAD_REQUESTS_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }
    case UPLOAD_REQUESTS_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPLOAD_REQUESTS_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UPLOAD_REQUESTS_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    default:
      return state;
  }
}
